import React from 'react';
import { Stack } from '@mui/material';

const ActionButtons = ({
    handleStateRequirementCheck,
    stateReqLoading,
    handleClientRequirementCheck,
    clientReqLoading,
    handleEscalationCheck,
    escalationLoading,
}) => (
    <Stack direction="row">
    </Stack>
);

export default ActionButtons;
